import React from 'react';

import { FloorGameTierLabel } from '@pkg/floorGame';

import { OrnamentTier3, OrnamentTier4 } from './images';

import { Image, StyledOrnament } from './styles';

export interface OrnamentProps {
    tier?: FloorGameTierLabel;
}

export function Ornament({ tier = FloorGameTierLabel.Tier1 }: OrnamentProps) {
    const tier3 = tier === FloorGameTierLabel.Tier3 ? <Image src={OrnamentTier3} alt="" /> : null;
    const tier4 =
        tier === FloorGameTierLabel.Tier4 || tier === FloorGameTierLabel.Tier5 ? (
            <Image src={OrnamentTier4} alt="" />
        ) : null;

    const hasOrnament = Boolean(tier3 || tier4);

    return hasOrnament ? <StyledOrnament>{tier3 || tier4}</StyledOrnament> : null;
}
